export default __webpack_public_path__ + "static/media/SWT0930.34I-22188_-15053_0.1c27968d.jpg";